import React, { useState } from "react";
import { DownloadOutlined } from "@ant-design/icons";
import { ModalItem, ButtonItem } from "../../../../Components/Items";
import useEsMovil from "./useEsMovil";

/**
 * Miniaturas clicables de las imágenes adjuntas a un TicketSoporte, con vista
 * previa en modal — mismo patrón que la subida de imágenes de Insumos
 * (EditarInsumo.js: handlePreview + ModalItem con <img> + botón de descarga).
 */
const ImagenesTicket = ({ imagenes }) => {
  const [preview, setPreview] = useState(null); // { url, nombre } | null
  const esMovil = useEsMovil();

  if (!imagenes?.length) return null;

  return (
    <>
      <div style={{ display: "flex", gap: 8, flexWrap: "wrap", padding: "8px 12px" }}>
        {imagenes.map((ruta) => {
          const url = `/${ruta}`;
          const nombre = ruta.split("/").pop();
          return (
            <img
              key={ruta}
              src={url}
              alt={nombre}
              onClick={() => setPreview({ url, nombre })}
              style={{
                width: 64,
                height: 64,
                objectFit: "cover",
                borderRadius: 6,
                border: "1px solid #f0f0f0",
                cursor: "pointer",
              }}
            />
          );
        })}
      </div>

      <ModalItem
        visible={!!preview}
        title={preview?.nombre}
        onCancel={() => setPreview(null)}
        footer={null}
        destroyOnClose
        spinning={false}
        width={esMovil ? undefined : 450}
      >
        {preview && (
          <>
            <img alt="vista previa" style={{ width: "100%" }} src={preview.url} />
            <div style={{ textAlign: "center", marginTop: 16 }}>
              <a href={preview.url} download={preview.nombre} style={{ textDecoration: "none" }}>
                <ButtonItem type="primary" icon={<DownloadOutlined />}>
                  Descargar
                </ButtonItem>
              </a>
            </div>
          </>
        )}
      </ModalItem>
    </>
  );
};

export default ImagenesTicket;
